import { LOCALE_ID, Provider } from '@angular/core';

import { SntI18nService } from './i18n.service';

export class SntLocaleId extends String {
  constructor(private i18nService: SntI18nService) {
    super();
  }

  override toString(): string {
    return this.i18nService.currentLocale;
  }

  override valueOf(): string {
    return this.toString();
  }
}

export const SntLocaleProvider: Provider = {
  provide: LOCALE_ID,
  useClass: SntLocaleId,
  deps: [SntI18nService],
};
